import { Fetch } from 'lib';
import { createSpecialOffer } from 'services';

type RequestResponses = Awaited<ReturnType<typeof createSpecialOffer>>;

type RequestParameters = {
  id: string;
};

type RequestBody = Parameters<typeof createSpecialOffer>[number];

const updateSpecialOffer = async (
  params: RequestParameters,
  body: RequestBody,
) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminSpecialOffer/updateSpecialOffer',
    method: 'PUT',
    params,
    body,
  });

export { updateSpecialOffer };
